// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { Alert } from '@innolab-trader/tradovate-types'

export interface CreateAlert {
  expression: string
  validUntil?: string
  triggerLimits?: number
  message?: string
}

export interface AlertResponse {
  errorText?: string
  alert?: Alert
}

/**
 * Validate CreateAlert request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateCreateAlert(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateCreateAlert(request: CreateAlert): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.expression === undefined || req.expression === null) {
    errors.push({
      field: 'expression',
      code: 'required',
      message: 'expression is required'
    })
  }
  if (typeof req.expression === 'string' && req.expression.length > 4096) {
    errors.push({
      field: 'expression',
      code: 'too_long',
      message: 'expression must not exceed 4096 characters',
      argument: '4096'
    })
  }
  if (typeof req.expression === 'string' && req.expression.trim() === '') {
    errors.push({
      field: 'expression',
      code: 'required',
      message: 'expression cannot be empty'
    })
  }

  if (typeof req.message === 'string' && req.message.length > 256) {
    errors.push({
      field: 'message',
      code: 'too_long',
      message: 'message must not exceed 256 characters',
      argument: '256'
    })
  }

  return errors
}

export const createAlert = postEndpoint<CreateAlert, AlertResponse>('/alert/createAlert')
